import * as React from 'react';
import * as PropTypes from 'prop-types';

import { useState, useEffect, useRef } from 'react';

import { Icon } from './../Icon';

import {
  TimePickerWrapper,
  TimePickerStyled,
  TimePickerInput,
  TimePickerIcon,
  TimePickerList,
  TimePickerItem
} from './styled';

interface Props {
  name?: string;
  time?: string;
  width?: string;
  fullWidth?: boolean;
  onChange?: Function;
  error?: boolean;
  disabled?: boolean;
  getTimeSelected?: Function;
  uncontrolled?: boolean;
  currentTime?: boolean;
}

export const TimePicker: React.FC<Props> = ({
  name,
  time = '',
  width,
  fullWidth,
  error,
  disabled,
  getTimeSelected,
  onChange,
  uncontrolled,
  currentTime,
  ...rest
}) => {

  const [ show, setShow ] = useState(false);
  const [ value, setValue ] = useState(time);

  useEffect(() => {
    uncontrolled && setValue(time);
  })

  const ref = useRef(null);

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
  })

  const handleOutsideClick = (e) => {
    const isOutside = !ref.current.contains(e.target);
    isOutside && setShow(false);
  }

  const showTimeFromNow = (items) => {
    let hours = new Date().getHours();
    let minutes = new Date().getMinutes();
    for(hours; hours<=23; hours++) {
      if (minutes < 30) {
        items.push(`${hours}:30`);
        if (hours !== 23) {
          items.push(`${hours + 1}:00`);
        }
      }
      if (minutes >= 30) {
        if (hours === 23) {
          items.push('00:00');
        } else {
          items.push(`${hours + 1}:00`);
          items.push(`${hours + 1}:30`);
        }
      }
    }
  }

  const TimePickerLisItem = ({setTime}) => {
    var i = 0;
    let items = [];
    if (currentTime) {
      showTimeFromNow(items);
    } else {
      for (i = 0; i < 24; i++) {
        items.push(i + ':00');
        items.push(i + ':30');
      }
    }

    const handleClick = (e) => {
      let time = e.target.innerText;
      setTime(time);
    }

    const formatTime = (time) => {
      return time.length == 4 ? `0${time}`: time;
    }

    return(
      <>
        {items.map((data, index) => (
          <TimePickerItem
            key={index}
            onClick={handleClick}
          >
            {formatTime(data)}
          </TimePickerItem>
        ))}
      </>
    );
  }

  const getTime = (time) => {
    setValue(time);
    setShow(false);

    getTimeSelected && getTimeSelected(time);
    onChange && onChange(time);
  }

  return (
    <TimePickerWrapper
      ref={ref}
      width={width}
      fullWidth={fullWidth}
      disabled={disabled}
    >
      <TimePickerStyled onClick={() => setShow(!show)}>
        <TimePickerInput
          name={name}
          type="text"
          placeholder="00:00"
          readOnly
          {...rest}
          value={value}
          error={error}
        />
        <TimePickerIcon>
          <Icon name="chevron-down" color="#B6B6B6"/>
        </TimePickerIcon>
      </TimePickerStyled>
      { show && (
        <TimePickerList data-test="generateUlTimeExpire">
          <TimePickerLisItem
            setTime={getTime}/>
        </TimePickerList>
      )}
    </TimePickerWrapper>
  );
}

TimePicker.propTypes = {
  time: PropTypes.string,
  width: PropTypes.string,
  fullWidth: PropTypes.bool,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  getTimeSelected: PropTypes.func,
  uncontrolled: PropTypes.bool
}

TimePicker.defaultProps = {
  width: '200px'
}
